/* ======================================================================================
DISABLE/ENABLE select input on change of radio buttons(one time and subscribe)
 ====================================================================================== */
document.body.addEventListener('change', function(e) {
  if (e.target.matches('[id^="quick-add-"] [name="purchase_option"]')) {
    const cardSubscribeForm = e.target.closest('.card-subscribe-form');
    
    const checkedRadio = cardSubscribeForm.querySelector('input[name="purchase_option"]:checked');
    
    const cardSubscribeInputWrapper = checkedRadio.closest('.card--subscribe-input-wrapper');
    const selectInput = cardSubscribeInputWrapper ? cardSubscribeInputWrapper.querySelector('.card-product-select_input') : null;
    
    if (selectInput) {
      selectInput.disabled = false;
      return;
    }
    cardSubscribeForm.querySelectorAll('.card-product-select_input').forEach(input => {
      input.disabled = true;
    });
  }
}); 